import { Observable, fromEvent, merge, Subject, timer, Subscription } from 'rxjs';
import { Injectable } from "@angular/core";

@Injectable()
export class IdleTimeoutService {

  private idle$: Observable<any>;
  private timer$: Subscription[] = [];
  private timeOutMilliSeconds: number;
  private idleSubscription;

  public expired$: Subject<boolean> = new Subject<boolean>();

  constructor() {

  }

  public startWatching(timeOutSeconds): Observable<any> {
    this.idle$ = merge(
      fromEvent(document, 'click'),
      fromEvent(document, 'keypress'),
    );

    this.timeOutMilliSeconds = timeOutSeconds * 1000;

    this.idleSubscription = this.idle$.subscribe((res) => {
      this.resetTimer();
    });

    this.startTimer();

    return this.expired$;
  }

  private startTimer() {
    console.log("startTimer " + this.timer$.length);
    this.timer$.push(timer(this.timeOutMilliSeconds, this.timeOutMilliSeconds).subscribe((res) => {
      this.expired$.next(true);
      console.log("Expired next called");
      this.timerUnsubcribe();
    }));
  }
  timerUnsubcribe() {
    this.timer$.forEach(sb => sb.unsubscribe());
    this.timer$ = [];
  }
  public resetTimer() {
    console.log("reset time");
    var now = new Date();
    console.log(now);

    this.timerUnsubcribe();
    this.startTimer();

  }

  public stopTimer() {
    console.log("stop Timer");
    var now = new Date();

    console.log(now);
    this.timerUnsubcribe();
    this.idleSubscription.unsubscribe();
  }
}
